/* eslint-disable react/prop-types */
import React from 'react';
import { Col, Divider, Empty, Form, Input, InputNumber } from 'antd';

function ScheduleSettings({ fieldsPermissions }) {
  const hasSchedulePermissions = fieldsPermissions?.FinishMargin.access !== 0;

  const hasManagerContactPermissions = fieldsPermissions?.ManagerContact.access !== 0;
  const hasLogisticsContactPermissions = fieldsPermissions?.LogisticsContact.access !== 0;
  const hasTransportContactPermissions = fieldsPermissions?.TransportContact.access !== 0;

  if (
    !hasSchedulePermissions &&
    !hasManagerContactPermissions &&
    !hasLogisticsContactPermissions &&
    !hasTransportContactPermissions
  )
    return (
      <div style={{ height: 100, width: '100%' }}>
        <Empty description="Nenhuma configuração de agendamento disponível" />
      </div>
    );

  return (
    <>
      {hasSchedulePermissions && (
        <Col span={24}>
          <Divider className="configuration-divider" orientation="left">
            Agenda
          </Divider>
        </Col>
      )}

      {fieldsPermissions?.FinishMargin.access !== 0 && (
        <Col span={6}>
          <Form.Item
            label="Tempo de Pré-Conclusão (Min)"
            name="conclusionMargin"
            rules={[
              {
                required: fieldsPermissions?.FinishMargin.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <InputNumber
              min={0}
              max={480}
              placeholder="0"
              disabled={fieldsPermissions?.FinishMargin.access !== 2}
            />
          </Form.Item>
        </Col>
      )}

      {hasManagerContactPermissions && (
        <Col span={24}>
          <Divider className="configuration-divider" orientation="left">
            Contato Gestor (Envio de E-mail)
          </Divider>
        </Col>
      )}

      {fieldsPermissions?.ManagerContact.access !== 0 && (
        <Col span={6}>
          <Form.Item
            label="Nome"
            name="managerName"
            rules={[
              {
                required: fieldsPermissions?.ManagerContact.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.ManagerContact.access !== 2} />
          </Form.Item>
        </Col>
      )}

      {fieldsPermissions?.ManagerContact.access !== 0 && (
        <Col span={6}>
          <Form.Item
            label="Telefone"
            name="managerPhone"
            rules={[
              {
                required: fieldsPermissions?.ManagerContact.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.ManagerContact.access !== 2} />
          </Form.Item>
        </Col>
      )}

      {hasLogisticsContactPermissions && (
        <Col span={24}>
          <Divider className="configuration-divider" orientation="left">
            Contato Logística (Envio de E-mail)
          </Divider>
        </Col>
      )}

      {fieldsPermissions?.LogisticsContact.access !== 0 && (
        <Col span={6}>
          <Form.Item
            label="Nome"
            name="logisticsName"
            rules={[
              {
                required: fieldsPermissions?.LogisticsContact.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.LogisticsContact.access !== 2} />
          </Form.Item>
        </Col>
      )}

      {fieldsPermissions?.LogisticsContact.access !== 0 && (
        <Col span={6}>
          <Form.Item
            label="Telefone"
            name="logisticsPhone"
            rules={[
              {
                required: fieldsPermissions?.LogisticsContact.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.LogisticsContact.access !== 2} />
          </Form.Item>
        </Col>
      )}

      {hasTransportContactPermissions && (
        <Col span={24}>
          <Divider className="configuration-divider" orientation="left">
            Contato Transporte (Envio de E-mail)
          </Divider>
        </Col>
      )}

      {fieldsPermissions?.TransportContact.access !== 0 && (
        <Col span={6}>
          <Form.Item
            label="Nome"
            name="transportName"
            rules={[
              {
                required: fieldsPermissions?.TransportContact.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.TransportContact.access !== 2} />
          </Form.Item>
        </Col>
      )}

      {fieldsPermissions?.TransportContact.access !== 0 && (
        <Col span={6}>
          <Form.Item
            label="Telefone"
            name="transportPhone"
            rules={[
              {
                required: fieldsPermissions?.TransportContact.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Input disabled={fieldsPermissions?.TransportContact.access !== 2} />
          </Form.Item>
        </Col>
      )}
    </>
  );
}

export default ScheduleSettings;
